const wrapper = "_35sw1ohql46";
const word = "_35sw13sc53j";
const hyphenWrapper = "_35sh1ivy4ri";
const hyphenateButton = "_35sh189gv14";
const char = "_35sc1uyb02e";
const editToggle = "_35sei95dwy";
const editToggleArrow = "_35se154vs2n";

export { char, editToggle, editToggleArrow, hyphenWrapper, hyphenateButton, word, wrapper };
import "./atom.editable.word.style.linaria.module.css";
//# sourceMappingURL=atom.editable.word.style.js.map
